import { pipe } from 'ramda';
import React, { FC } from 'react';
import {
  PageContentWrapper,
  WidgetContainer,
} from 'components/organisms/projects-report/common';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { Content } from 'stores/core';
import { UsersReport, UsersReportRecord } from '../types';
import {
  BillableUtilizationWidget,
  CollaborationWidget,
  TaskOnTimeCompletionWidget,
  useWidgetData,
} from '../widgets';
import { UsersReportTable } from './table';

export const UsersReportContent: FC<{
  usersReport: UsersReport;
  range: DateRange;
}> = ({ usersReport, range }) => {
  const records = pipe(
    () => usersReport,
    Content.map((x) => x),
    Content.orElse([] as UsersReportRecord[]),
  )();

  const [isTimesheetFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );
  const { topTaskOnTimeCompletion, topComments, topBillableUtilization } =
    useWidgetData(usersReport);

  return (
    <PageContentWrapper>
      <WidgetContainer xs={24} md={12} lg={12} xl={8} xxl={6}>
        <TaskOnTimeCompletionWidget value={topTaskOnTimeCompletion} />
        {isTimesheetFeatureEnabled ? (
          <BillableUtilizationWidget value={topBillableUtilization} />
        ) : null}
        <CollaborationWidget value={topComments} />
      </WidgetContainer>
      <UsersReportTable usersReportRecords={records} range={range} />
    </PageContentWrapper>
  );
};
